require('./bootstrap');
import Alpine from 'alpinejs';
// import intersect from '@alpinejs/intersect';
import mask from '@alpinejs/mask';

// Alpine.plugin(intersect)
Alpine.plugin(mask);
window.Alpine = Alpine;
Alpine.start();

